export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_CHATGROUPS = 'SET_CHATGROUPS'
export const SET_CHATGROUP = 'SET_CHATGROUP'
export const SET_CHATMESSAGES = 'SET_CHATMESSAGES'
export const RESET_CHANNELS = 'RESET_CHANNELS'
export const RESET_MESSAGES = 'RESET_MESSAGES'
export const UPDATE_CHATGROUP = 'UPDATE_CHATGROUP'
export const SET_CHANNELS = 'SET_CHANNELS'

export const CHAT_SEARCH_TERM = 'CHAT_SEARCH_TERM'
export const CHAT_PAGE_SIZE = 'CHAT_PAGE_SIZE'
export const CHAT_SORT_DIR = 'CHAT_SORT_DIR'
export const CHAT_ORDER_BY = 'CHAT_ORDER_BY'
export const CHAT_FILTER_BY = 'CHAT_FILTER_BY'



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/types.js